import React from 'react';
import { useNotifications, Notification } from '../../context/NotificationContext';
import NotificationItem from './NotificationItem';
import NotificationFilters from './NotificationFilters';

interface NotificationDropdownProps {
  onClose: () => void;
  onNotificationClick: (notification: Notification) => void;
}

export const NotificationDropdown: React.FC<NotificationDropdownProps> = ({
  onClose,
  onNotificationClick,
}) => {
  const { notifications, filteredNotifications, unreadCount, markAllAsRead, isLoading } = useNotifications();

  const handleMarkAllRead = async () => {
    await markAllAsRead();
  };

  const handleNotificationClick = (notification: Notification) => {
    onNotificationClick(notification);
    onClose();
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: '100%',
        right: 0,
        width: '360px',
        maxWidth: 'calc(100vw - 32px)',
        backgroundColor: '#fff',
        borderRadius: '12px',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
        border: '1px solid #e2e8f0',
        marginTop: '8px',
        zIndex: 1000,
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px',
          borderBottom: '1px solid #e2e8f0',
          backgroundColor: '#f8fafc',
        }}
      >
        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1e293b' }}>
          Notifications
        </h3>
        {unreadCount > 0 && (
          <button
            onClick={handleMarkAllRead}
            style={{
              background: 'none',
              border: 'none',
              color: '#2563eb',
              fontSize: '13px',
              fontWeight: '500',
              cursor: 'pointer',
              padding: '8px 16px',
              borderRadius: '4px',
              minHeight: '44px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#eff6ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            Mark all as read
          </button>
        )}
      </div>

      {/* Filter bar */}
      <NotificationFilters />

      {/* Notification list */}
      <div
        style={{
          maxHeight: '400px',
          overflowY: 'auto',
        }}
      >
        {isLoading && filteredNotifications.length === 0 ? (
          <div style={{ padding: '40px 16px', textAlign: 'center', color: '#94a3b8' }}>
            Loading...
          </div>
        ) : filteredNotifications.length === 0 && notifications.length === 0 ? (
          <div style={{ padding: '40px 16px', textAlign: 'center', color: '#94a3b8' }}>
            No notifications yet
          </div>
        ) : filteredNotifications.length === 0 ? (
          <div style={{ padding: '40px 16px', textAlign: 'center', color: '#94a3b8' }}>
            No notifications match your filters
          </div>
        ) : (
          filteredNotifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onClick={handleNotificationClick}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationDropdown;
